import { render, staticRenderFns } from "./s06.vue?vue&type=template&id=405de822&scoped=true"
import script from "./s06.vue?vue&type=script&lang=js"
export * from "./s06.vue?vue&type=script&lang=js"
import style0 from "./s06.vue?vue&type=style&index=0&id=405de822&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "405de822",
  null
  
)

export default component.exports